


















import { Vue, Component } from 'vue-property-decorator';

@Component({})
export default class DoubleElevenEvent extends Vue {
  get userInfo() {
    return this.$store.getters.getUserInfo;
  }

  private visibleMask: boolean = false;

  mounted() {
    const timer = window.setInterval(() => {
      if(this.show()) {
        this.visibleMask = true;
        localStorage.DoubleElevenEvent2 = 'show';
      }
      if(localStorage.DoubleElevenEvent2 || this.visibleMask) {
        clearInterval(timer)
      }
    }, 200)
  }


  show() {
    // 已出现过
    if(localStorage.DoubleElevenEvent2) {
      return false;
    }
    // 学校判断
    if(this.userInfo.coid === '34090' || (this.userInfo.school && this.userInfo.school.includes('集美大学'))) {
      return false;
    }
    //如果已经是vip，并且是老师
    if(this.userInfo.isvip>0){
      return false;
    }
    const currentTime = Date.now();

    // 时间判断
    // 2021-11-11 00:00 ~ 2021-11-11 07:45
    const firstStart = new Date('2021/11/13').getTime();
    const firstEnd = new Date('2021/11/15').getTime();

    if(firstStart < currentTime && currentTime < firstEnd) {
      return true;
    } else {
      return false;
    }
  }

  closeMask() {
    this.visibleMask = false;
  }

};
